import { Outlet } from "react-router-dom"
import { AppSidebar } from "@/components/app-sidebar"
import { SiteHeader } from "@/components/site-header"
import { BenefitEditScope } from "@/components/benefit/benefit-edit-scope"
import { BuildDiagnostics } from "@/components/build-diagnostics"
import {
  SidebarInset,
  SidebarProvider,
} from "@/components/ui/sidebar"

export default function AppLayout() {
  return (
    <BenefitEditScope>
    <SidebarProvider
      style={
        {
          "--sidebar-width": "14rem",
          "--header-height": "calc(var(--spacing) * 12)",
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="sidebar" />
      <SidebarInset>
        <SiteHeader />
        <div className="flex flex-1 flex-col">
          <div className="app-content @container/main flex min-w-0 flex-1 flex-col gap-2">
            <Outlet />
            <BuildDiagnostics />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
    </BenefitEditScope>
  )
}
